export default {

};




// WEBPACK FOOTER //
// ./src/store/Getters.js